export default __webpack_public_path__ + "static/media/dinas3.c22e2386.png";